import { h } from 'preact';
import { PageShell } from '../PageShell';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'PageShell',
  category: '⏳ Loading',
  description: 'Container de página com loading automático via skeleton shimmer e fade-in',
  usedIn: ['AgentesPage', 'ChatHubPage', 'Integrations', 'ReferralDashboard'],
  example: () => (
    <div style={{ border: '1px solid rgba(255,255,255,0.06)', borderRadius: 8, padding: 12, maxHeight: 200, overflow: 'hidden' }}>
      <PageShell loading={true} skeleton="page"><div>Conteudo</div></PageShell>
    </div>
  ),
};
